import React, { Component } from "react";
import { Link } from "gatsby";
import { withLanguage } from "../i18n";
class NavOne extends Component {
  constructor() {
    super();
    this.state = {
      sticky: false
    };
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);

    //Mobile Menu
    this.mobileMenu();

    //Search Toggle
    this.serachButton();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    if (window.scrollY > 70) {
      this.setState({
        sticky: true
      });
    } else if (window.scrollY < 70) {
      this.setState({
        sticky: false
      });
    }
  };

  mobileMenu = () => {
    //Mobile Menu Toggle
    let mainNavToggler = document.querySelector(".menu-toggler");
    let mainNav = document.querySelector(".main-navigation");

    if (!mainNavToggler || !mainNav) return;

    mainNavToggler.addEventListener("click", function () {
      mainNav.style.display =
        mainNav.style.display !== "block" ? "block" : "none";
    });
  };

  serachButton = () => {
    let searchToggle = document.querySelector(".search-toggle");
    let searchPopup = document.querySelector(".search-popup");
    let searchClose = document.querySelector(".cancel");
    let searchOverlay = document.querySelector(".search-overlay");

    if (!searchToggle || !searchPopup || !searchClose || !searchOverlay) return;

    searchToggle.addEventListener("click", function () {
      searchPopup.classList.add("active");
    });

    searchClose.addEventListener("click", function () {
      searchPopup.classList.remove("active");
    });

    searchOverlay.addEventListener("click", function () {
      searchPopup.classList.remove("active");
    });
  };

  render() {
    const currentPath = typeof window !== "undefined" ? window.location.pathname : "/";
    const isCurrent = (path) => path === "/" ? currentPath === "/" : currentPath.startsWith(path);

    return (
      <header className="site-header site-header__header-one ">
        <nav
          className={`navbar navbar-expand-lg navbar-light header-navigation stricky ${
            this.state.sticky ? "stricked-menu stricky-fixed" : ""
          }`}
        >
          <div className="container clearfix">
            <div className="logo-box clearfix">
              <Link to="/" className="navbar-brand">
                <span className="ady-text-logo">Ánh Dương</span>
              </Link>
              <button className="menu-toggler">
                <span className="kipso-icon-menu"></span>
              </button>
            </div>
            <div className="main-navigation">
              <ul className=" navigation-box">
                <li className={isCurrent("/") ? "current" : ""}>
                  <Link to="/">{this.props.t.home}</Link>
                </li>
                <li className={isCurrent("/cong-giao-dich/giai-phap-cong-nghe-so") ? "current" : ""}>
                  <Link to="/cong-giao-dich/giai-phap-cong-nghe-so">{this.props.t.technology}</Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/cong-giao-dich/giai-phap-cong-nghe-so">
                        {this.props.t.technologySolutions}
                      </Link>
                    </li>
                    <li>
                      <Link to="/co-van-quan-tri-epc">
                        {this.props.t.technologyEpc}
                      </Link>
                    </li>
                    <li>
                      <Link to="/cong-giao-dich/giai-phap-cong-nghe-so">
                        {this.props.t.technologyAi}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className={isCurrent("/co-van-quan-tri-epc") ? "current" : ""}>
                  <Link to="/co-van-quan-tri-epc">{this.props.t.epc}</Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/co-van-quan-tri-epc/triet-ly-dieu-hanh">
                        {this.props.t.epcPhilosophy}
                      </Link>
                    </li>
                    <li>
                      <Link to="/co-van-quan-tri-epc/tham-dinh-doanh-nghiep">
                        {this.props.t.epcAssessment}
                      </Link>
                    </li>
                    <li>
                      <Link to="/co-van-quan-tri-epc/lo-trinh-co-van">
                        {this.props.t.epcRoadmap}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className={isCurrent("/hitech-talent") ? "current" : ""}>
                  <Link to="/hitech-talent">{this.props.t.talent}</Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/hitech-talent/su-menh-tu-cuong">
                        {this.props.t.talentMission}
                      </Link>
                    </li>
                    <li>
                      <Link to="/hitech-talent/nen-tang-nang-luc-solar">
                        {this.props.t.talentPlatform}
                      </Link>
                    </li>
                    <li>
                      <Link to="/hitech-talent/mang-luoi-tinh-hoa">
                        {this.props.t.talentNetwork}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className={isCurrent("/tin-tuc") ? "current" : ""}>
                  <Link to="/tin-tuc">{this.props.t.news}</Link>
                </li>
                <li className={`d-none ${isCurrent("/cong-giao-dich") ? "current" : ""}`}>
                  <Link to="/cong-giao-dich">{this.props.t.portal}</Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/cong-giao-dich/tham-dinh-doanh-nghiep">
                        {this.props.t.portalAssessment}
                      </Link>
                    </li>
                    <li>
                      <Link to="/hitech-talent">
                        {this.props.t.portalTalent}
                      </Link>
                    </li>
                    <li>
                      <Link to="/cong-giao-dich/giai-phap-cong-nghe-so">
                        {this.props.t.portalTechnology}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className={`d-none ${isCurrent("/xac-minh-danh-tinh") ? "current" : ""}`}>
                  <Link to="/xac-minh-danh-tinh">{this.props.t.identity}</Link>
                </li>
                <li className={`d-none ${isCurrent("/thu-vien-cua-toi") ? "current" : ""}`}>
                  <Link to="/thu-vien-cua-toi">{this.props.t.library}</Link>
                </li>
              </ul>
            </div>
            <div className="right-side-box">
              <a
                className="header__search-btn search-popup__toggler search-toggle"
                href="#none"
              >
                <i className="kipso-icon-magnifying-glass"></i>
              </a>
            </div>
          </div>
        </nav>
        <div className="site-header__decor">
          <div className="site-header__decor-row">
            <div className="site-header__decor-single">
              <div className="site-header__decor-inner-1"></div>
            </div>
            <div className="site-header__decor-single">
              <div className="site-header__decor-inner-2"></div>
            </div>
            <div className="site-header__decor-single">
              <div className="site-header__decor-inner-3"></div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default withLanguage(NavOne);
